import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/devtools/airwallex")({
  component: lazyRouteComponent(() => import("./+Airwallex")),
  head: () => ({ meta: seo({ title: "Airwallex" }) }),
});
